// import Vue from 'vue'
import { model } from 'vue-state-tree'
import router from './router'
import axios from 'axios'
import { setDocumentFavicon } from './lib/favicon'

const feathers = require('@feathersjs/feathers')
const rest = require('@feathersjs/rest-client')
const auth = require('@feathersjs/authentication-client')

const app = feathers()

// Connect to a different URL
// const restClient = rest('http://localhost:3030')
const restClient = rest(process.env.VUE_APP_API_URL)
// const restClient = rest('https://welcome-backend.birkenbeul.rocks')

// Configure an AJAX library (see below) with that client
// app.configure(restClient.fetch(window.fetch));
app.configure(restClient.axios(axios))
// Available options are listed in the "Options" section
app.configure(auth({
  storageKey: 'auth'
}))

let lastErrorTime = 0
const EVENT_DATE_FIELDS = ['startDate', 'endDate']

function isValidDateObject (value) {
  return value instanceof Date && !Number.isNaN(value.getTime())
}

function parseLocalDateTimeString (value) {
  const localDateMatch = /^(\d{4})-(\d{2})-(\d{2})(?:[ T])(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value)
  if (!localDateMatch) {
    return null
  }

  const [, year, month, day, hour, minute, second = '0'] = localDateMatch
  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second)
  )
}

function normalizeEventDateValue (value) {
  if (value == null || value === '') {
    return null
  }

  if (isValidDateObject(value)) {
    return value
  }

  if (typeof value === 'string' || value instanceof String) {
    const trimmedValue = value.trim()
    const parsedLocalDate = parseLocalDateTimeString(trimmedValue)
    if (isValidDateObject(parsedLocalDate)) {
      return parsedLocalDate
    }

    const parsedDate = new Date(trimmedValue)
    if (isValidDateObject(parsedDate)) {
      return parsedDate
    }
  }

  return null
}

function serializeEventDateValue (value) {
  if (value == null || value === '') {
    return null
  }

  const normalizedValue = normalizeEventDateValue(value)
  return normalizedValue ? normalizedValue.toISOString() : value
}

function serializeEventDateFields (data) {
  const serializedData = { ...data }

  for (const fieldName of EVENT_DATE_FIELDS) {
    if (Object.prototype.hasOwnProperty.call(serializedData, fieldName)) {
      serializedData[fieldName] = serializeEventDateValue(serializedData[fieldName])
    }
  }

  return serializedData
}

axios.interceptors.response.use((response) => {
  return response
}, async (error) => {
  let thisErrorTime = new Date().getTime()
  if (thisErrorTime - lastErrorTime < 1000 && lastErrorTime != 0) {
    lastErrorTime = thisErrorTime
    return
  }
  lastErrorTime = thisErrorTime
  if (error.response) {
    try {
      if (programmer.user.state.isLoggedIn) {
        await app.service('errorlog').create({ type: 'frontend', browser: navigator.userAgent, error: JSON.stringify(error.response) })
      }
    } catch (err) {
      console.log('err', err)
    }
    if (error.response.data.name == 'NotAuthenticated' && error.response.data.message != 'Invalid login') {
      router.push({ name: 'login' })
    }
  }
  return Promise.reject(error)
})

const programmer = model({
  name: 'programmer',
  data () {
    return {
      user: {
        data: {},
        state: {
          isLoggedIn: false
        }
      },
      app: {
        url: process.env.VUE_APP_SELF_URL,
        imageHost: process.env.VUE_APP_IMAGE_HOST,
        registerUrl: process.env.VUE_APP_REGISTER_URL,
        reAuthRoute: null,
        state: {
          isLoading: false
        }
      },
      dashboard: {
        events: [],
        participants: []
      },
      events: {
        curentEvent: {},
        currentAmountOfReceivers: {},
        eventMails: [],
        currentCustomFields: {},
        data: []
      },
      participants: {
        byEvent: [],
        byId: {},
        currentCustomFieldsData: {},
        editMode: false
      },
      state: {
        firstName: 'Brian',
        lastName: 'Kernighan',
        language: 'C'
      }
    }
  },
  mounted () {

  },
  computed: {
    compEvents () {
      return this.events.data.map((event) => {
        event.comp = {}
        let startDate = new Date(event.startDate)
        const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
        event.comp.startDate = startDate.toLocaleDateString('de-DE', options)
        event.comp.active = event.isVisible ? 'ja' : 'nein'
        return event
      })
    },
    compParticipants () {
      return this.participants.byEvent.map((participant) => {
        let filingDate = new Date(participant.createdAt)
        const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }
        participant.filingDate = filingDate.toLocaleDateString('de-DE', options)

        participant.fullName = participant.name + ', ' + participant.forename
        return participant
      })
    },
    fullName: {
      get () {
        return this.state.firstName + ' ' + this.state.lastName
      },
      set (value) {
        [ this.state.firstName, this.state.lastName ] = value.split(' ')
      }
    },
    loginState: {
      get () {
        return this.user.state.isLoggedIn
      },
      set (val) {
        this.user.state.isLoggedIn = val
      }
    }
  },
  methods: {
    async setFirstName (value) {
      this.state.firstName = value
    },
    async goTo (routeName, param = {}) {
      router.push({ name: routeName, params: param }).catch(() => {})
    },
    async setReAauthRoute () {
      this.app.reAuthRoute = location.pathname
    },
    normalizeEventDateValue (value) {
      return normalizeEventDateValue(value)
    },
    serializeEventDateFields (data) {
      return serializeEventDateFields(data)
    },
    resetEvent () {
      this.events.curentEvent = {}
    },
    async login (username, password) {
      this.app.state.isLoading = true
      try {
        console.log('login1')
        let response = await app.authenticate({
          strategy: 'local',
          email: username,
          password: password
        })
        console.log('response', response)
        this.user.state.isLoggedIn = true
        this.user.data = response.user
        await this.getUserData()
        router.push('dashboard').catch(() => {})
      } catch (err) {
        console.error('Authentication error', err)
        this.app.state.isLoading = false
        throw err
      }
    },
    async register (username, password) {
      // console.log("register")
      app.service('users').create({
        email: username,
        password: password
      }).then((response) => {

      }).catch((e) => {
        console.error('Register error', e)
      })
    },
    async getUserData () {
      this.app.state.isLoading = true
      try {
        const response = await app.service('users').get(this.user.data.id)
        this.user.data = response
        setDocumentFavicon(response.faviconUrl)
        console.log(response)
      } catch (e) {
        console.error('getUserData error', e)
        throw e
      } finally {
        this.app.state.isLoading = false
      }
    },
    async patchUserData (id, data) {
      this.app.state.isLoading = true
      try {
        const patchOptions = {}
        if (typeof FormData !== 'undefined' && data instanceof FormData) {
          patchOptions.headers = {
            'Content-Type': 'multipart/form-data'
          }
        }
        let response = await app.service('users').patch(id, data, patchOptions)
        this.user.data = response
        setDocumentFavicon(response.faviconUrl)
      } catch (err) {
        console.error('patchUserData error', err)
        throw err
      } finally {
        this.app.state.isLoading = false
      }
    },
    async patchParticipantData (id, data) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('participant').patch(id, data)
        // this.participants.byId = response
      } catch (err) {
        console.error('patchParticipantData error', err)
        throw err
      } finally {
        this.app.state.isLoading = false
      }
    },
    async reAuth () {
      this.app.state.isLoading = true
      try {
        let response = await app.reAuthenticate()
        this.user.data = response.user
        this.user.state.isLoggedIn = true
        await this.getUserData()
        router.push(this.app.reAuthRoute).catch(() => {})
      } catch (err) {
        this.app.state.isLoading = false
        this.user.state.isLoggedIn = false
        setDocumentFavicon(null)
        console.error('reAuth', err)
        throw err
      } finally {
        this.app.state.isLoading = false
      }
    },
    async logout () {
      this.app.state.isLoading = true
      console.log('logout')
      app.logout().then(() => {
        this.user.state.isLoggedIn = false
        setDocumentFavicon(null)
        this.app.state.isLoading = false
        router.push('/').catch(() => {})
      }).catch((e) => {
        this.app.state.isLoading = false
        console.error('logout error', e)
      })
    },
    async getEvents () {
      this.app.state.isLoading = true
      try {
        let response = await app.service('event').find({
          query: {
            $limit: 500,
            $select: [ 'id', 'title', 'startDate', 'endDate', 'maxParticipants', 'createdAt', 'updatedAt', 'city', 'street', 'zip', 'country', 'url', 'type', 'website', 'isVisible' ],
            $sort: {
              id: -1
            }
          }
        })
        this.app.state.isLoading = false
        this.events.data = response.data
      } catch (err) {
        this.app.state.isLoading = false
        console.error('getEvents error', err)
      }
    },
    async getActiveEvents () {
      this.app.state.isLoading = true
      try {
        let response = await app.service('event').find({
          query: {
            $limit: 13337,
            $select: [ 'id', 'title', 'startDate', 'endDate', 'maxParticipants', 'isVisible' ],
            isVisible: { $ne: 0 },
            $sort: { 'startDate': -1 }
          }
        })
        this.dashboard.events = response.data
      } catch (err) {
        console.error('getActiveEvents error', err)
      }
      this.app.state.isLoading = false
    },
    async getEventById (id, select) {
      this.app.state.isLoading = true
      let query = {}
      if (select) {
        query.$select = select
      }
      try {
        let response = await app.service('event').get(id, { query })
        this.app.state.isLoading = false
        this.events.curentEvent = response
        return response
      } catch (err) {
        this.app.state.isLoading = false
        console.error('getEventById error', err)
      }
    },
    async createEvent (data) {
      this.app.state.isLoading = true
      const payload = this.serializeEventDateFields({
        ...data,
        userId: this.user.data.id
      })
      try {
        let response = await app.service('event').create(payload)
        this.app.state.isLoading = false
        router.push('events').catch(() => {})
      } catch (err) {
        this.app.state.isLoading = false
        console.error('createEvent error', err)
        throw err
      }
    },
    async copyEvent (id) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('event').create({}, { query: { copyFromEventId: id } })
        this.app.state.isLoading = false
        return response
      } catch (err) {
        console.error('copyEvent error', e)
        throw err
      }
    },
    async patchEvent (id, data) {
      this.app.state.isLoading = true
      const payload = this.serializeEventDateFields({
        ...data,
        userId: this.user.data.id
      })
      try {
        let response = await app.service('event').patch(id, payload)
        this.app.state.isLoading = false
        return response
        // this.events.curentEvent = {}
        // router.push({name:'events'})
      } catch (err) {
        this.app.state.isLoading = false
        console.error('patchEvent error', err)
        throw err
      }
    },
    async deleteEvent (id) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('event').remove(id)
        this.getEvents()
      } catch (err) {
        console.error('deleteEvent error', err)
      }
      this.app.state.isLoading = false
    },
    async emptyDashboardData () {
      store.dashboard.events = []
      store.dashboard.participants = []
    },
    async emptyCurentEvent () {
      store.events.curentEvent = {}
      store.events.currentCustomFields = {}
    },
    async emptyCurrentParticipant () {
      store.events.curentEvent = {}
      store.events.currentCustomFields = {}
      store.participants.byId = {}
      store.participants.currentCustomFieldsData = {}
    },
    async getCustomFieldByEventId (id) {
      this.app.state.isLoading = true
      app.service('custom-field').find({ query: { eventId: id } }).then((response) => {
        this.app.state.isLoading = false
        this.events.currentCustomFields = response
      }).catch((e) => {
        this.app.state.isLoading = false
        console.error('getCustomFieldByEventId error', e)
      })
    },
    async createCustomField (paramsData) {
      let data = Object.assign({}, paramsData)
      this.app.state.isLoading = true
      if (data.values) {
        data.values = JSON.stringify(data.values)
      }
      try {
        let result = await app.service('custom-field').create(data)
        paramsData.id = result.id
      } catch (err) {
        console.error('createCustomField error', err)
      }
      this.app.state.isLoading = false
    },
    async patchCustomField (id, paramsData) {
      let data = Object.assign({}, paramsData)
      this.app.state.isLoading = true
      if (data.values) {
        data.values = JSON.stringify(data.values)
      }
      try {
        await app.service('custom-field').patch(id, data)
        // this.events.currentCustomFields = {}
      } catch (err) {
        console.error('patchCustomField error', err)
      }
      this.app.state.isLoading = false
    },
    async deleteCustomField (id) {
      this.app.state.isLoading = true
      app.service('custom-field').remove(id).then((response) => {
        this.app.state.isLoading = false
        console.log(response)
        this.getEvents()
      }).catch((e) => {
        this.app.state.isLoading = false
        console.error('deleteCustomField error', e)
      })
    },
    async getParticipantsByEventId (id, addCustomFields) {
      this.app.state.isLoading = true
      if (addCustomFields !== true) {
        addCustomFields = false
      }
      try {
        let response = await app.service('participant')
          .find({
            query: {
              eventId: id,
              // $select:['id','title','name','forename', 'email', 'createdAt'],
              $limit: 13337,
              addCustomFields: addCustomFields
            }
          })
        this.participants.byEvent = response.data
      } catch (err) {
        console.error('getParticipantsByEventId error', err)
      } finally {
        this.app.state.isLoading = false
      }
    },
    async getParticipantDatesByEventId (id) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('participant')
          .find({
            query: {
              eventId: id,
              $select: ['createdAt', 'eventId', 'emailConfirmed', 'allowMarketing', 'visitedLanding', 'hasParticipated'],
              $sort: {
                createdAt: 1
              },
              $limit: 5000
            }
          })
        return response
      } catch (err) {
        console.error('getParticipantsByEventId error', err)
      } finally {
        this.app.state.isLoading = false
      }
    },
    addToDashboardParticipants (participants) {
      this.dashboard.participants = [...this.dashboard.participants, ...participants]
    },
    async getParticipantById (id) {
      this.app.state.isLoading = true
      app.service('participant').get(id).then((response) => {
        this.app.state.isLoading = false
        this.participants.byId = response
      }).catch((e) => {
        this.app.state.isLoading = false
        console.error('getParticipantById error', e)
      })
    },
    async getCustomFieldDataById (id) {
      this.app.state.isLoading = true
      app.service('custom-field-data')
        .find({ query: { participantId: id, $select: ['id', 'value', 'customFieldId'] } })
        .then((response) => {
          let dataArr = response.data
          let tmpArr = []
          dataArr.forEach(elem => {
            let tmpObj = {}
            tmpObj.dataId = elem.id
            tmpObj.customFieldId = elem.customFieldId
            tmpObj.value = elem.value
            tmpObj.oldValue = elem.value
            tmpArr.push(tmpObj)
          })
          response.data = tmpArr

          this.app.state.isLoading = false
          this.participants.currentCustomFieldsData = response
        }).catch((e) => {
          this.app.state.isLoading = false
          console.error('getCustomFieldDataById error', e)
        })
    },
    async createCustomFieldData (data) {
      this.app.state.isLoading = true
      app.service('custom-field-data')
        .create(data)
        .then((response) => {
          this.app.state.isLoading = false
          this.participants.currentCustomFieldsData = response
        }).catch((e) => {
          this.app.state.isLoading = false
          console.error('createCustomFieldData error', e)
        })
    },
    async patchCustomFieldDataById (data) {
      this.app.state.isLoading = true
      app.service('custom-field-data')
        .patch(data.id, data)
        .then((response) => {
          this.app.state.isLoading = false
        // this.participants.currentCustomFieldsData = response
        }).catch((e) => {
          this.app.state.isLoading = false
          console.error('patchCustomFieldDataById error', e)
        })
    },
    async deleteCustomFieldDataById (id) {
      this.app.state.isLoading = true
      app.service('custom-field-data').remove(id).then((response) => {
        this.app.state.isLoading = false
        // this.participants.byEvent = response
      }).catch((e) => {
        this.app.state.isLoading = false
        console.error('deleteCustomFieldDataById error', e)
      })
    },
    async deleteParticipantById (id) {
      this.app.state.isLoading = true
      app.service('participant').remove(id).then((response) => {
        this.app.state.isLoading = false
        // this.participants.byEvent = response
      }).catch((e) => {
        this.app.state.isLoading = false
        console.error('deleteParticipantById error', e)
      })
    },
    async confirmParticipation (id, confirmationToken) {
      console.log('confirmpart')
      try {
        let res = await app.service('participant').patch(id, { confirmationToken })
        return res
      } catch (err) {
        throw err
      }
    },
    async getEventLandingData (eventId, userIdentifier, previewKey) {
      console.log('get event landing data')
      try {
        const query = { getPrivacyUrl: true }
        if (userIdentifier) query.userIdentifier = userIdentifier
        if (previewKey) query.previewKey = previewKey
        let res = await app.service('event').get(eventId, { query })
        return res
      } catch (err) {
        throw err
      }
    },
    async getEventLandingDataUrl (eventId, userIdentifier, previewKey) {
      console.log('get event landing data')
      try {
        const query = { $select: ['url'] }
        if (userIdentifier) query.userIdentifier = userIdentifier
        if (previewKey) query.previewKey = previewKey
        let res = await app.service('event').get(eventId, { query })
        return res
      } catch (err) {
        throw err
      }
    },
    async setVisit (participantId, userIdentifier) {
      try {
        let res = await app.service('participant').patch(participantId, {}, { query: { identifier: userIdentifier, setVisit: 1 } })
        return res
      } catch (err) {
        throw err
      }
    },
    async setClick (participantId, userIdentifier) {
      try {
        let res = await app.service('participant').patch(participantId, {}, { query: { identifier: userIdentifier, setParticipation: 1 } })
        return res
      } catch (err) {
        throw err
      }
    },
    async disableEditModeParticipant () {
      this.participants.editMode = false
    },
    async enableEditModeParticipant () {
      this.participants.editMode = true
    },
    async getEventMails (id) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('eventmail').find({
          query: {
            eventId: id,
            $limit: 500,
            $select: [ 'id', 'subject', 'text', 'filter', 'sendHoursRelativeToEventStart', 'jobStartedAt', 'jobFinishedAt', 'amountOfRecipients', 'amountOfSuccess', 'amountOfFailed', 'active', 'type', 'sendInvitation' ]
          } })
        this.events.eventMails = response.data
        return response
      } catch (err) {
        console.error('getEventMails error', err)
      } finally {
        this.app.state.isLoading = false
      }
    },
    async getEventMail (id) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('eventmail').get(id)
        this.app.state.isLoading = false
        return response
      } catch (err) {
        console.error('getEventMail error', err)
        this.app.state.isLoading = false
        throw err
      }
    },
    async patchEventMail (data) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('eventmail').patch(data.id, data)
        this.events.eventMails = this.events.eventMails.map((mail) => {
          if (mail.id === response.id) return response
          return mail
        })
        this.app.state.isLoading = false
        return response
      } catch (err) {
        console.error('patchEventMail error', err)
        this.app.state.isLoading = false
        throw err
      }
    },
    async createEventMail (data) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('eventmail').create(data)
        this.app.state.isLoading = false
        return response
      } catch (err) {
        console.error('createEventMail error', err)
        this.app.state.isLoading = false
        throw err
      }
    },
    async removeEventMail (id) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('eventmail').remove(id)
        this.app.state.isLoading = false
        return response
      } catch (err) {
        console.error('removeEventMail error', err)
        this.app.state.isLoading = false
        throw err
      }
    },
    async sendTestMail (item, email) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('mail').create({
          action: 'sendTestMail',
          mailId: item.id,
          email: email
        })
        this.app.state.isLoading = false
        return response
      } catch (err) {
        console.error('sendTestMail error', err)
        this.app.state.isLoading = false
        throw err
      }
    },
    async sendCustomMail (item) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('mail').create({
          action: 'sendCustomMail',
          mailId: item.id
        })
        this.app.state.isLoading = false
        return response
      } catch (err) {
        console.error('sendCustomMail error', err)
        this.app.state.isLoading = false
        throw err
      }
    },
    async uploadImage (eventId, image, type) {
      this.app.state.isLoading = true
      let formData = new FormData()
      formData.append('file', image)
      formData.append('eventId', eventId)
      formData.append('type', type)
      try {
        let response = await app.service('uploads').create(formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          } })
        this.app.state.isLoading = false
        return response
      } catch (err) {
        console.error('uploadImage error', err)
        this.app.state.isLoading = false
        throw err
      }
    },
    async countParticipantsByEventId (eventId, getConfirmed) {
      let q = {
        $limit: 0,
        eventId: eventId
      }
      if (getConfirmed) {
        q.emailConfirmed = { $gt: '2000-01-01' }
      }
      try {
        let response = await app.service('participant').find({
          query: q
        })
        return response.total
      } catch (err) {
        console.error('countParticipantsByEventId error', err)
        throw err
      }
    },
    async countCustomEmailsByEventId (eventId) {
      let q = {
        $limit: 0,
        eventId: eventId,
        type: 'custom'
      }
      try {
        let response = await app.service('eventmail').find({
          query: q
        })
        return response.total
      } catch (err) {
        console.error('countCustomEmailsByEventId error', err)
        throw err
      }
    },
    async getImage (eventId, type) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('uploads').find({
          query: {
            eventId: eventId,
            type: type,
            $select: ['id', 'filename']
          }
        })
        this.app.state.isLoading = false
        if (response.total) return response.data[0]
        else return false
      } catch (err) {
        this.app.state.isLoading = false
        console.error('getImage error', err)
        throw err
      }
    },
    async removeImage (id) {
      this.app.state.isLoading = true
      try {
        let response = await app.service('uploads').remove(id)
        this.app.state.isLoading = false
        return response
      } catch (err) {
        this.app.state.isLoading = false
        console.error('removeImage error', err)
        throw err
      }
    },
    /*
    get all active event mails
    check if automated start of mail is before current time => message confirm "mails will be sent immidiatly"
    check if automated mails will be sent in future => message "mails will be sent in future. please check."
    */
    async checkIfMailsWeBeSent (eventId) {
      let eventMails = app.service('eventmail').find({ query: {
        eventId: eventId,
        active: 1
      } })
    },
    async setCustomMailsInactive (eventId) {
      try {
        let mails = await app.service('eventmail').find({
          query: {
            eventId: eventId,
            type: 'custom',
            $limit: 5000,
            $select: ['id']
          } })
        for (let mail of mails.data) {
          await app.service('eventmail').patch(mail.id, { active: false }, {})
        }
      } catch (err) {
        console.error('setCustomMailsInactive', err)
      }
    },
    async getAmountOfReceivers (eventId) {
      let all, confirmed, unconfirmed, hasParticipated, notParticipated
      try {
        all = await app.service('participant').find({
          query: {
            eventId: eventId,
            $limit: 0
          } })

        confirmed = await app.service('participant').find({
          query: {
            eventId: eventId,
            emailConfirmed: { $gt: '2000-01-01' },
            $limit: 0
          } })

        unconfirmed = all.total - confirmed.total

        hasParticipated = await app.service('participant').find({
          query: {
            eventId: eventId,
            hasParticipated: { $gt: '2000-01-01' },
            $limit: 0
          } })

        notParticipated = all.total - hasParticipated.total
      } catch (err) {
        console.error('getAmountOfReceivers', err)
      }
      let res = {
        all: all.total,
        unconfirmed: unconfirmed,
        confirmed: confirmed.total,
        hasParticipated: hasParticipated.total,
        notParticipated: notParticipated
      }
      this.events.currentAmountOfReceivers = res
      return res
    }
  }
})

export const store = programmer
